import http from "../../helpers/http";
import * as helpers from "../../helpers/helpers";
import { toast } from "react-toastify";
import { TOAST_SETTINGS } from "../../utils/siteSettings";
import Text from "../../components/common/Text";

import {
  FETCH_JOBS_CONTENT,
  FETCH_JOBS_CONTENT_SUCCESS,
  FETCH_JOBS_CONTENT_FAILED,
  FETCH_JOBS_SEARCH,
  FETCH_JOBS_SEARCH_SUCCESS,
  FETCH_JOBS_SEARCH_FAILED,
  SAVE_JOB,
  SAVE_JOB_SUCCESS,
  SAVE_JOB_FAILED,
  JOB_APPLIED,
  JOB_APPLIED_SUCCESS,
  JOB_APPLIED_FAILED,
  REPORT_AN_JOB,
  REPORT_AN_JOB_SUCCESS,
  REPORT_AN_JOB_FAILED,
  REPORT_AN_JOB_POPUP
} from "./actionTypes";
import { getAuthUserToken } from "../../helpers/authToken";

// A failed request is not a failed login. The API rejects a bad token with
// HTTP 400 and {"error":1}; anything else (500, timeout, dropped connection)
// is the server having a bad moment and says nothing about the session.
// Clearing the token on every error is what turned server faults into
// "the site keeps logging me out" for paying members.
const isTokenRejection = (error) => {
  const res = error?.response;
  return res?.status === 400 && res?.data?.error === 1;
};

const handleRequestFailure = (error) => {
  if (isTokenRejection(error)) {
    localStorage.removeItem("authToken");
    window.location.reload();
    return;
  }
  toast.error(
    "We couldn't load jobs just then - please try again in a moment.",
    TOAST_SETTINGS
  );
};

export const fetchJobs = (formData) => (dispatch) => {
  dispatch({
    type: FETCH_JOBS_CONTENT,
    payload: null
  });
  http
    .post(
      "jobs",
      helpers.doObjToFormData({ ...formData,token: getAuthUserToken() })
    )
    .then(({ data }) => {
      dispatch({
        type: FETCH_JOBS_CONTENT_SUCCESS,
        payload: data
      });
    })
    .catch((error) => {
      dispatch({
        type: FETCH_JOBS_CONTENT_FAILED,
        payload: error
      });
      handleRequestFailure(error);
    });
};

// The job board still has more than one effect that can fire the same search
// on mount (see JobList.jsx). Rather than keep chasing them one by one, drop a
// search that is byte-for-byte identical to one issued in the last second:
// that is never a user asking for something new, it is a duplicate render.
// fetch-jobs-data is the most expensive endpoint on the site (100+ queries)
// and the PHP-FPM pool has 50 workers, so halving its traffic matters.
let lastSearchKey = null;
let lastSearchAt = 0;
const DUPLICATE_WINDOW_MS = 1000;

export const searchJobsData = (post) => (dispatch) => {
  post = { ...post, token: getAuthUserToken() };
  const key = JSON.stringify(post);
  const now = Date.now();
  if (key === lastSearchKey && now - lastSearchAt < DUPLICATE_WINDOW_MS) {
    return;
  }
  lastSearchKey = key;
  lastSearchAt = now;
  dispatch({
    type: FETCH_JOBS_SEARCH,
    payload: null
  });
  http
    .post("fetch-jobs-data", helpers.doObjToFormData(post))
    .then(({ data }) => {
      // document.getElementById("job__block").scrollIntoView();
      window.scrollTo({ top: 300, behavior: "smooth" });
      dispatch({
        type: FETCH_JOBS_SEARCH_SUCCESS,
        payload: data
      });
    })
    .catch((error) => {
      dispatch({
        type: FETCH_JOBS_SEARCH_FAILED,
        payload: error
      });
      handleRequestFailure(error);
    });
};

export const saveJobAction = (formData) => (dispatch) => {
  let jobId = formData.id;
  if (getAuthUserToken()) {
    dispatch({
      type: SAVE_JOB,
      payload: null
    });
    formData = { ...formData, token: getAuthUserToken() };
    http
      .post("save-job", helpers.doObjToFormData(formData))
      .then(({ data }) => {
        if (data.status) {
          data = { ...data, id: jobId };
          toast.success("Job Saved Successfully.", TOAST_SETTINGS);
          dispatch({
            type: SAVE_JOB_SUCCESS,
            payload: data
          });
        } else {
          dispatch({
            type: SAVE_JOB_FAILED,
            payload: null
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: SAVE_JOB_FAILED,
          payload: error
        });
        handleRequestFailure(error);
      });
  } else {
    toast.error("Please signin first to save this job post.", TOAST_SETTINGS);
  }
};

export const applyJob = (formData) => (dispatch) => {
  let jobId = formData.id;
  if (getAuthUserToken()) {
    dispatch({
      type: JOB_APPLIED,
      payload: null
    });
    formData = { ...formData, token: getAuthUserToken() };
    http
      .post("user/job-applied", helpers.doObjToFormData(formData))
      .then(({ data }) => {
        if (data.status) {
          data = { ...data, id: jobId };
          toast.success("Job applied successfully.", TOAST_SETTINGS);
          dispatch({
            type: JOB_APPLIED_SUCCESS,
            payload: data
          });
        } else {
          dispatch({
            type: JOB_APPLIED_FAILED,
            payload: null
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: JOB_APPLIED_FAILED,
          payload: error
        });
        handleRequestFailure(error);
      });
  } else {
    toast.error("Please signin first to save this job post.", TOAST_SETTINGS);
  }
};

export const reportAnJobPopup = () => (dispatch) => {
  dispatch({
    type: REPORT_AN_JOB_POPUP,
    payload: null
  });
};
export const reportAnJob = (formData) => (dispatch) => {
  // let jobId = formData.id;
  if (getAuthUserToken()) {
    dispatch({
      type: REPORT_AN_JOB,
      payload: null
    });
    formData = { ...formData, token: getAuthUserToken() };
    http
      .post("user/report-an-job", helpers.doObjToFormData(formData))
      .then(({ data }) => {
        if (data.status) {
          // data = { ...data, id: jobId };
          toast.success(
            "You have successfully reported the job.",
            TOAST_SETTINGS
          );
          setTimeout(() => {
            dispatch({
              type: REPORT_AN_JOB_SUCCESS,
              payload: data
            });
          }, 800);
        } else {
          dispatch({
            type: REPORT_AN_JOB_FAILED,
            payload: null
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: REPORT_AN_JOB_FAILED,
          payload: error
        });
        handleRequestFailure(error);
      });
  } else {
    toast.error("Please signin first to save this job post.", TOAST_SETTINGS);
  }
};
